import { useDispatch } from "react-redux";
import React, { Fragment } from "react";
import { Typography, Grid } from "@mui/material";

import { useAxios } from "../../../../hooks";
import Paper from "../../../../components/Paper";
import { colors } from "../../../css components/Style";
import { alert } from "../../../../redux/slices/alertSlice";
import { PrimaryLoadingButton } from "../../../css components/Button";

export default function SummaryDialog({ campaignID, summary }) {
  const axios = useAxios();
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            style={{ marginTop: "30px", color: colors.sideBarColor }}
          >
            Channel Summary
          </Typography>
        </Grid>

        {summary?.length > 0 &&
          summary?.map((sum) => (
            <Grid item xs={4}>
              <Paper>
                <Grid item xs={12} style={{ alignItems: "center" }}>
                  {Object.keys(sum).map((s) => (
                    <Fragment>
                      <Typography color={colors.lightGreen} variant="h5">
                        {s}
                      </Typography>
                      <div style={{ paddingBottom: "10px" }} />

                      {s === "Whatsapp" && (
                        <Typography
                          style={{
                            textWrap: "nowrap",
                            fontSize: "13px",
                          }}
                          variant="caption1"
                        >
                          Whatsapp Tier {sum[s]?.whatsapp_tier}
                        </Typography>
                      )}

                      {s !== "Whatsapp" && (
                        <Fragment>
                          <Typography
                            style={{
                              textWrap: "nowrap",
                              fontSize: "13px",
                            }}
                            variant="caption1"
                          >
                            Audience ID {sum[s]?.audience_id}
                          </Typography>

                          <div style={{ paddingBottom: "3px" }} />

                          <Typography
                            style={{
                              wordBreak: "break-all",
                              fontSize: "13px",
                            }}
                          >
                            {" "}
                            Audience Name {sum[s]?.audience_name}
                          </Typography>
                        </Fragment>
                      )}

                      <div style={{ paddingBottom: "10px" }} />
                      <Typography style={{ display: "flex" }} variant="h6">
                        Status &nbsp; <Status s={sum[s]} />
                      </Typography>

                      {sum[s].status === "FAILED" && (
                        <div style={{ padding: "10px" }} />
                      )}
                      {sum[s].status === "FAILED" && (
                        <PrimaryLoadingButton
                          onClick={() => handleRetry(s)}
                          variant="outlined"
                        >
                          Retry
                        </PrimaryLoadingButton>
                      )}
                    </Fragment>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          ))}
      </Grid>
    </React.Fragment>
  );

  function handleRetry(s) {
    axios({
      url: "/retry/launchCampaign'",
      method: "POST",
      data: {
        campaign_id: campaignID,
        channel: s,
      },
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({
            type: "success",
            message: "",
          })
        );
      }
    });
  }

  function Status({ s }) {
    if (s.status === "FAILED") {
      return (
        <Typography variant="h6" color={colors.error}>
          {s.status}
        </Typography>
      );
    }

    if (s.status === "UPLOADED") {
      return (
        <Typography variant="h6" color={colors.iconColor}>
          {s.status}
        </Typography>
      );
    }

    if (s.status === "IN_PROCESS") {
      return (
        <Typography variant="h6" color={colors.initiated}>
          {s.status?.replace(/_/, " ")}
        </Typography>
      );
    }

    if (s.status === "N/A") {
      return (
        <Typography variant="h6" color={colors.warning}>
          {"N/A"}
        </Typography>
      );
    }
    return "";
  }
}
